
import Bar from '@/components/charts/Bar.vue';
import Line from '@/components/charts/Line.vue';
import Pie from '@/components/charts/Pie.vue';
import Radar from '@/components/charts/Radar.vue';
import Bubble from '@/components/charts/Bubble.vue';
import Doughnut from '@/components/charts/Doughnut.vue';
import HorizontalBar from '@/components/charts/HorizontalBar.vue';
import StackedBar from '@/components/charts/StackedBar.vue';
import StackedHorizontalBar from '@/components/charts/StackedHorizontalBar.vue';
import PolarArea from '@/components/charts/PolarArea.vue';
import Scatter from '@/components/charts/Scatter.vue';

export default {
  'bar-chart': Bar,
  'line-chart': Line,
  'pie-chart': Pie,
  'radar-chart': Radar,
  'bubble-chart': Bubble,
  'doughnut-chart': Doughnut,
  'horizontalbar-chart': HorizontalBar,
  'stacked-bar-chart': StackedBar,
  'stacked-horizontal-bar-chart': StackedHorizontalBar,
  'polar-chart': PolarArea,
  'scatter-chart': Scatter,
};
